import LinkSVG from './Link.svg';

export default ({ vendor, tabbable }) => (
  <a tabIndex={tabbable ? 0 : -1} href={vendor.policyUrl} target="_blank" className="vendor-tag linked">
    <span role="text">{vendor.name}</span>
    <img src={LinkSVG} alt="" />
  </a>
);